import Vue from 'vue'
import App from './App.vue'
import router from "./router"
import store from "./store"
import { mixin } from '../src/common/mixin';

import MyHttpServer from 'plugin/http'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../src/assets/theme/index.css'
import VueClipboard from 'vue-clipboard2'
import VueCookies from 'vue-cookies'
import { Base64 } from 'js-base64'

import VueQuillEditor from 'vue-quill-editor'
import quillEmoji, { QuillEmoji } from "quill-emoji";

import VueCropper from 'vue-cropper'
// 瀑布流 ： https://blog.csdn.net/weixin_41455147/article/details/107669425
import waterfall from 'vue-waterfall2'
import UmyUi from 'umy-ui'

import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme

// hms云函数 相关
import agconnect from '@hw-agconnect/api'
import '@hw-agconnect/function'
import '@hw-agconnect/instance'

// hms 云函数
var agConnectConfig = {
  agcgw: {
    backurl: 'connect-drcn.hispace.hicloud.com',
    url: 'connect-drcn.dbankcloud.cn',
    websocketbackurl: 'connect-ws-drcn.hispace.dbankcloud.com',
    websocketurl: 'connect-ws-drcn.hispace.dbankcloud.cn',
  },
  agcgw_all: {
    CN: 'connect-drcn.dbankcloud.cn',
    CN_back: 'connect-drcn.hispace.hicloud.com',
    DE: 'connect-dre.dbankcloud.cn',
    DE_back: 'connect-dre.hispace.hicloud.com',
    RU: 'connect-drru.hispace.dbankcloud.ru',
    RU_back: 'connect-drru.hispace.dbankcloud.cn',
    SG: 'connect-dra.dbankcloud.cn',
    SG_back: 'connect-dra.hispace.hicloud.com',
  },
  websocketgw_all: {
    CN: 'connect-ws-drcn.hispace.dbankcloud.cn',
    CN_back: 'connect-ws-drcn.hispace.dbankcloud.com',
    DE: 'connect-ws-dre.hispace.dbankcloud.cn',
    DE_back: 'connect-ws-dre.hispace.dbankcloud.com',
    RU: 'connect-ws-drru.hispace.dbankcloud.ru',
    RU_back: 'connect-ws-drru.hispace.dbankcloud.cn',
    SG: 'connect-ws-dra.hispace.dbankcloud.cn',
    SG_back: 'connect-ws-dra.hispace.dbankcloud.com',
  },
  client: {
    cp_id: '30086000555685321',
    product_id: '99536292102886156',
    client_id: '1067567715650129664',
    client_secret:
      '5A16020A941AE75F4C1DDB5E28E2E3A49DD9B4F78DA1307EE2165637FF7DA2BA',
    project_id: '99536292102886156',
    app_id: '172249065902322190',
    api_key:
      'DAEDAN/EofieIH+nVw9jTXGaeJqYmLSus7fTd88ycPyprglhQZn7BZlEqOYyAVut2/CqD/yoIyOh5m+YVPFjlmXaUsnFO7QlfHBy+A==',
  },
  oauth_client: {
    client_id: '107751901',
    client_type: 7,
  },
  app_info: {
    app_id: '172249065902322190',
  },
  service: {
    analytics: {
      collector_url:
        'datacollector-drcn.dt.hicloud.com,datacollector-drcn.dt.dbankcloud.cn',
      collector_url_ru:
        'datacollector-drru.dt.dbankcloud.ru,datacollector-drru.dt.hicloud.com',
      collector_url_sg:
        'datacollector-dra.dt.hicloud.com,datacollector-dra.dt.dbankcloud.cn',
      collector_url_de:
        'datacollector-dre.dt.hicloud.com,datacollector-dre.dt.dbankcloud.cn',
      collector_url_cn:
        'datacollector-drcn.dt.hicloud.com,datacollector-drcn.dt.dbankcloud.cn',
      resource_id: 'p1',
      channel_id: '',
    },
    edukit: {
      edu_url: 'edukit.edu.cloud.huawei.com.cn',
      dh_url: 'edukit.edu.cloud.huawei.com.cn',
    },
    search: {
      url: 'https://search-drcn.cloud.huawei.com',
    },
    cloudstorage: {
      storage_url_sg_back: 'https://agc-storage-dra.cloud.huawei.asia',
      storage_url_ru_back: 'https://agc-storage-drru.cloud.huawei.ru',
      storage_url_ru: 'https://agc-storage-drru.cloud.huawei.ru',
      storage_url_de_back: 'https://agc-storage-dre.cloud.huawei.eu',
      storage_url_de: 'https://ops-dre.agcstorage.link',
      storage_url: 'https://agc-storage-drcn.platform.dbankcloud.cn',
      storage_url_sg: 'https://ops-dra.agcstorage.link',
      storage_url_cn_back: 'https://agc-storage-drcn.cloud.huawei.com.cn',
      storage_url_cn: 'https://agc-storage-drcn.platform.dbankcloud.cn',
    },
    ml: {
      mlservice_url:
        'ml-api-drcn.ai.dbankcloud.com,ml-api-drcn.ai.dbankcloud.cn',
    },
  },
  region: 'CN',
  configuration_version: '3.0',
}

//初始化agc
agconnect.instance().configInstance(agConnectConfig)

// hms 云数据库
import 'babel-polyfill';
import "@hw-agconnect/database";


// 通过全局方法 Vue.use() 使用插件
Vue.use(VueCropper)  // 图片裁切 https://github.com/xyxiao001/vue-cropper
Vue.use(ElementUI);
Vue.use(MyHttpServer);
Vue.use(VueQuillEditor);
Vue.use(waterfall)
Vue.use(VueClipboard);
Vue.use(VueCookies);
Vue.use(Base64);
// Vue.use(QuillEmoji)

// 全局混入
Vue.mixin(mixin);
Vue.use(UmyUi);

// 注册$ip 作为全局变量，Vue.prototype 定义全局属性。

// 2.0
// Vue.prototype.$ip = "MyHttpServer.upload_id"
Vue.prototype.$store = store
Vue.prototype.$agconnect = agconnect

Vue.config.productionTip = false




// 动态改变浏览器标签栏title
Vue.directive('title', {
  inserted: (el, binding) => {
    document.title = binding.value;
  }
})

// 挂载
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
